export default __webpack_public_path__ + "static/media/logo.47c6a353.png";